@if (command()) {
  <p-dialog [(visible)]="isVisible"
            [modal]="true"
            [closable]="false"
            [styleClass]="showDiscount() ? 'dialog-expanded' : 'dialog-default'">
    <div class="flex flex-column">
      <div class="text-lg-semibold text-gray-900">
        Potvrda slanja fakture
      </div>
      <div class="mt-1 text-sm-regular text-gray-600">Potvrdite status zahteva da ste uspešno poslali fakturu klijentu.</div>
      <div class="mt-3-5 flex align-items-center justify-content-between">
        <div class="text-md-semibold text-gray-900">Cena</div>
        <div class="text-md-regular text-gray-700">{{command()!.packagePrice.originalPrice! | currencyNumber}}</div>
      </div>
      <div class="mt-3 flex align-items-center justify-content-between">
        <div class="text-md-semibold text-gray-900">Popust</div>
        <app-toggle-button [(isChecked)]="showDiscount"></app-toggle-button>
      </div>
      @if (showDiscount()) {
        <app-text-input
          class="mt-3 w-full"
          [hasIcon]="true"
          [formCtrl]="discountPrice | formControl"
          [isNumberInput]="true"
          currency="EUR"
          formCtrlClass="w-full"
        >
          <app-currency-euro-circle stroke="#ADB0B8"></app-currency-euro-circle>
        </app-text-input>
        <div class="mt-3 flex align-items-center justify-content-between">
          <div class="text-md-semibold text-gray-900">Konačna cena</div>
          <div class="text-md-regular text-gray-700">{{command()!.packagePrice.price! | currencyNumber}}</div>
        </div>
      }
    </div>
    <ng-template #header>
      <div class="flex align-items-center justify-content-between w-full">
        <div class="flex justify-content-center align-items-center icon">
          <app-check-circle stroke="#414651" width="20px" height="20px"></app-check-circle>
        </div>
        <app-x-close stroke="#ADB0B8" width="12" height="12" class="cursor-pointer" (click)="onCancel()"></app-x-close>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="mt-5 flex justify-content-end align-items-center w-full">
        <app-button [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.MD" (btnClicked)="onCancel()">
          <div class="text-sm-semibold text-gray-900">Otkaži</div>
        </app-button>
        <app-button class="ml-2-5" [btnSeverity]="ButtonSeverity.PRIMARY" [btnSize]="ButtonSize.MD" (btnClicked)="onSubmit()">
          <div class="text-sm-semibold text-white">Potvrdi</div>
        </app-button>
      </div>
    </ng-template>
  </p-dialog>
}

